module.exports = __webpack_public_path__ + "static/media/footerLogo.0f500b80.svg";